// this is an autogenerated file from App/Account/Content/Tasks/mutation-move-task.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($id: uuid!, $stage_id: uuid!, $board_id: uuid!) {
  update_tasks_tasks_by_pk(
    pk_columns: { id: $id }
    _set: { stage_id: $stage_id, board_id: $board_id }
  ) {
    id
  }
}

`